<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="(key) => selectConnectorsBy(key)" />
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class matchSizeMenus extends Vue {
        get menuList() {
            return {
                list: [
                    { key: "lineColor", label: this.$t("lineColor") },
                    { key: "textColor", label: this.$t("textColor") },
                ],
            };
        }
        selectConnectorsBy(type) {
            window["_view"].selAllConnectors(type);
            this.$track("select", "same type line", type);
            this.$emit("closeDrop");
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "lineColor": "连接线颜色",
    "textColor": "文本颜色"
  },
  "en": {
    "lineColor": "Connecting line color",
    "textColor": "Text Color"
  },
  "fr": {
    "lineColor": "Couleur de ligne de connexion",
    "textColor": "Couleur du texte"
  },
  "de": {
    "lineColor": "Verbindungslinienfarbe",
    "textColor": "Textfarbe"
  },
  "jp": {
    "lineColor": "接続線の色",
    "textColor": "テキストの色"
  },
  "es": {
    "lineColor": "Color de la línea de conexión",
    "textColor": "Color del texto"
  },
  "pt": {
    "lineColor": "Conectando a cor da linha",
    "textColor": "Cor do Texto"
  },
  "it": {
    "lineColor": "Colore linea di collegamento",
    "textColor": "Colore testo"
  },
  "tw": {
    "lineColor": "連接線顏色",
    "textColor": "文本顏色"
  }
}
</i18n>
